/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiAddFinalRiskOverride,
    InternalApiAddFinalRiskOverrideFromJSON,
    InternalApiAddFinalRiskOverrideToJSON,
    InternalApiAddFinalRiskOverrideReason,
    InternalApiAddFinalRiskOverrideReasonFromJSON,
    InternalApiAddFinalRiskOverrideReasonToJSON,
    InternalApiBulkRiskOverrideCommand,
    InternalApiBulkRiskOverrideCommandFromJSON,
    InternalApiBulkRiskOverrideCommandToJSON,
    InternalApiFinalRiskLevel,
    InternalApiFinalRiskLevelFromJSON,
    InternalApiFinalRiskLevelToJSON,
    InternalApiFinalRiskOverride,
    InternalApiFinalRiskOverrideFromJSON,
    InternalApiFinalRiskOverrideToJSON,
    InternalApiFinalRiskOverrideHistoryPage,
    InternalApiFinalRiskOverrideHistoryPageFromJSON,
    InternalApiFinalRiskOverrideHistoryPageToJSON,
    InternalApiFinalRiskOverrideReason,
    InternalApiFinalRiskOverrideReasonFromJSON,
    InternalApiFinalRiskOverrideReasonToJSON,
    InternalApiFinalRiskOverrideReasonPage,
    InternalApiFinalRiskOverrideReasonPageFromJSON,
    InternalApiFinalRiskOverrideReasonPageToJSON,
    InternalApiFinalRiskRangeEntry,
    InternalApiFinalRiskRangeEntryFromJSON,
    InternalApiFinalRiskRangeEntryToJSON,
} from '../models';

export interface AddOverrideRequest {
    personId: string;
    internalApiAddFinalRiskOverride: InternalApiAddFinalRiskOverride;
}

export interface AddOverrideReasonRequest {
    internalApiAddFinalRiskOverrideReason: InternalApiAddFinalRiskOverrideReason;
}

export interface ArchiveOverrideReasonRequest {
    handle: string;
}

export interface BulkOverrideRequest {
    internalApiBulkRiskOverrideCommand: InternalApiBulkRiskOverrideCommand;
}

export interface EditOverrideReasonRequest {
    handle: string;
    internalApiAddFinalRiskOverrideReason: InternalApiAddFinalRiskOverrideReason;
}

export interface EndOverrideRequest {
    personId: string;
}

export interface FindAllOverrideReasonsRequest {
    page: number;
    size: number;
}

export interface FindArchivedOverrideReasonsRequest {
    page: number;
    size: number;
}

export interface FindOverrideHistoryRequest {
    personId: string;
    page: number;
    size: number;
}

export interface RestoreOverrideReasonRequest {
    handle: string;
}

/**
 * 
 */
export class FinalRiskApi extends runtime.BaseAPI {

    /**
     * Adds risk override for specific person
     */
    async addOverrideRaw(requestParameters: AddOverrideRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiFinalRiskOverride>> {
        if (requestParameters.personId === null || requestParameters.personId === undefined) {
            throw new runtime.RequiredError('personId','Required parameter requestParameters.personId was null or undefined when calling addOverride.');
        }

        if (requestParameters.internalApiAddFinalRiskOverride === null || requestParameters.internalApiAddFinalRiskOverride === undefined) {
            throw new runtime.RequiredError('internalApiAddFinalRiskOverride','Required parameter requestParameters.internalApiAddFinalRiskOverride was null or undefined when calling addOverride.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/risk/final-risk/{personId}/overrides`.replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters.personId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiAddFinalRiskOverrideToJSON(requestParameters.internalApiAddFinalRiskOverride),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiFinalRiskOverrideFromJSON(jsonValue));
    }

    /**
     * Adds risk override for specific person
     */
    async addOverride(requestParameters: AddOverrideRequest, initOverrides?: RequestInit): Promise<InternalApiFinalRiskOverride> {
        const response = await this.addOverrideRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Adds new final risk override reason
     * Adds new final risk override reason
     */
    async addOverrideReasonRaw(requestParameters: AddOverrideReasonRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.internalApiAddFinalRiskOverrideReason === null || requestParameters.internalApiAddFinalRiskOverrideReason === undefined) {
            throw new runtime.RequiredError('internalApiAddFinalRiskOverrideReason','Required parameter requestParameters.internalApiAddFinalRiskOverrideReason was null or undefined when calling addOverrideReason.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/risk/final-risk/override-reasons`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiAddFinalRiskOverrideReasonToJSON(requestParameters.internalApiAddFinalRiskOverrideReason),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Adds new final risk override reason
     * Adds new final risk override reason
     */
    async addOverrideReason(requestParameters: AddOverrideReasonRequest, initOverrides?: RequestInit): Promise<void> {
        await this.addOverrideReasonRaw(requestParameters, initOverrides);
    }

    /**
     * Archives final risk override reason
     * Archives final risk override reason
     */
    async archiveOverrideReasonRaw(requestParameters: ArchiveOverrideReasonRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.handle === null || requestParameters.handle === undefined) {
            throw new runtime.RequiredError('handle','Required parameter requestParameters.handle was null or undefined when calling archiveOverrideReason.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/risk/final-risk/override-reasons/{handle}/archive`.replace(`{${"handle"}}`, encodeURIComponent(String(requestParameters.handle))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Archives final risk override reason
     * Archives final risk override reason
     */
    async archiveOverrideReason(requestParameters: ArchiveOverrideReasonRequest, initOverrides?: RequestInit): Promise<void> {
        await this.archiveOverrideReasonRaw(requestParameters, initOverrides);
    }

    /**
     * Bulk override risk for multiple persons
     */
    async bulkOverrideRaw(requestParameters: BulkOverrideRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.internalApiBulkRiskOverrideCommand === null || requestParameters.internalApiBulkRiskOverrideCommand === undefined) {
            throw new runtime.RequiredError('internalApiBulkRiskOverrideCommand','Required parameter requestParameters.internalApiBulkRiskOverrideCommand was null or undefined when calling bulkOverride.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/risk/final-risk/bulk-overrides`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiBulkRiskOverrideCommandToJSON(requestParameters.internalApiBulkRiskOverrideCommand),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Bulk override risk for multiple persons
     */
    async bulkOverride(requestParameters: BulkOverrideRequest, initOverrides?: RequestInit): Promise<void> {
        await this.bulkOverrideRaw(requestParameters, initOverrides);
    }

    /**
     * Archives final risk override reason
     * Archives final risk override reason
     */
    async editOverrideReasonRaw(requestParameters: EditOverrideReasonRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiFinalRiskOverrideReason>> {
        if (requestParameters.handle === null || requestParameters.handle === undefined) {
            throw new runtime.RequiredError('handle','Required parameter requestParameters.handle was null or undefined when calling editOverrideReason.');
        }

        if (requestParameters.internalApiAddFinalRiskOverrideReason === null || requestParameters.internalApiAddFinalRiskOverrideReason === undefined) {
            throw new runtime.RequiredError('internalApiAddFinalRiskOverrideReason','Required parameter requestParameters.internalApiAddFinalRiskOverrideReason was null or undefined when calling editOverrideReason.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/risk/final-risk/override-reasons/{handle}`.replace(`{${"handle"}}`, encodeURIComponent(String(requestParameters.handle))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiAddFinalRiskOverrideReasonToJSON(requestParameters.internalApiAddFinalRiskOverrideReason),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiFinalRiskOverrideReasonFromJSON(jsonValue));
    }

    /**
     * Archives final risk override reason
     * Archives final risk override reason
     */
    async editOverrideReason(requestParameters: EditOverrideReasonRequest, initOverrides?: RequestInit): Promise<InternalApiFinalRiskOverrideReason> {
        const response = await this.editOverrideReasonRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * End risk override for specific person
     */
    async endOverrideRaw(requestParameters: EndOverrideRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.personId === null || requestParameters.personId === undefined) {
            throw new runtime.RequiredError('personId','Required parameter requestParameters.personId was null or undefined when calling endOverride.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/risk/final-risk/{personId}/overrides`.replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters.personId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * End risk override for specific person
     */
    async endOverride(requestParameters: EndOverrideRequest, initOverrides?: RequestInit): Promise<void> {
        await this.endOverrideRaw(requestParameters, initOverrides);
    }

    /**
     * Fetches all final risk override reasons of organisation
     * Fetches all final risk override reasons of organisation
     */
    async findAllOverrideReasonsRaw(requestParameters: FindAllOverrideReasonsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiFinalRiskOverrideReasonPage>> {
        if (requestParameters.page === null || requestParameters.page === undefined) {
            throw new runtime.RequiredError('page','Required parameter requestParameters.page was null or undefined when calling findAllOverrideReasons.');
        }

        if (requestParameters.size === null || requestParameters.size === undefined) {
            throw new runtime.RequiredError('size','Required parameter requestParameters.size was null or undefined when calling findAllOverrideReasons.');
        }

        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/risk/final-risk/override-reasons`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiFinalRiskOverrideReasonPageFromJSON(jsonValue));
    }

    /**
     * Fetches all final risk override reasons of organisation
     * Fetches all final risk override reasons of organisation
     */
    async findAllOverrideReasons(requestParameters: FindAllOverrideReasonsRequest, initOverrides?: RequestInit): Promise<InternalApiFinalRiskOverrideReasonPage> {
        const response = await this.findAllOverrideReasonsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches archived final risk override reasons of organisation
     * Fetches archived final risk override reasons of organisation
     */
    async findArchivedOverrideReasonsRaw(requestParameters: FindArchivedOverrideReasonsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiFinalRiskOverrideReasonPage>> {
        if (requestParameters.page === null || requestParameters.page === undefined) {
            throw new runtime.RequiredError('page','Required parameter requestParameters.page was null or undefined when calling findArchivedOverrideReasons.');
        }

        if (requestParameters.size === null || requestParameters.size === undefined) {
            throw new runtime.RequiredError('size','Required parameter requestParameters.size was null or undefined when calling findArchivedOverrideReasons.');
        }

        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/risk/final-risk/override-reasons/archived`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiFinalRiskOverrideReasonPageFromJSON(jsonValue));
    }

    /**
     * Fetches archived final risk override reasons of organisation
     * Fetches archived final risk override reasons of organisation
     */
    async findArchivedOverrideReasons(requestParameters: FindArchivedOverrideReasonsRequest, initOverrides?: RequestInit): Promise<InternalApiFinalRiskOverrideReasonPage> {
        const response = await this.findArchivedOverrideReasonsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Possible final risk level for this organisation
     */
    async findFinalRiskLevelsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<InternalApiFinalRiskLevel>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/risk/final-risk/levels`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InternalApiFinalRiskLevelFromJSON));
    }

    /**
     * Possible final risk level for this organisation
     */
    async findFinalRiskLevels(initOverrides?: RequestInit): Promise<Array<InternalApiFinalRiskLevel>> {
        const response = await this.findFinalRiskLevelsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Final risk level score ranges configured for this organisation
     */
    async findFinalRiskLevelsV2Raw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<InternalApiFinalRiskRangeEntry>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v2/risk/final-risk/levels`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InternalApiFinalRiskRangeEntryFromJSON));
    }

    /**
     * Final risk level score ranges configured for this organisation
     */
    async findFinalRiskLevelsV2(initOverrides?: RequestInit): Promise<Array<InternalApiFinalRiskRangeEntry>> {
        const response = await this.findFinalRiskLevelsV2Raw(initOverrides);
        return await response.value();
    }

    /**
     * Fetches person final risk override history
     */
    async findOverrideHistoryRaw(requestParameters: FindOverrideHistoryRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiFinalRiskOverrideHistoryPage>> {
        if (requestParameters.personId === null || requestParameters.personId === undefined) {
            throw new runtime.RequiredError('personId','Required parameter requestParameters.personId was null or undefined when calling findOverrideHistory.');
        }

        if (requestParameters.page === null || requestParameters.page === undefined) {
            throw new runtime.RequiredError('page','Required parameter requestParameters.page was null or undefined when calling findOverrideHistory.');
        }

        if (requestParameters.size === null || requestParameters.size === undefined) {
            throw new runtime.RequiredError('size','Required parameter requestParameters.size was null or undefined when calling findOverrideHistory.');
        }

        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/risk/final-risk/{personId}/override-history`.replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters.personId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiFinalRiskOverrideHistoryPageFromJSON(jsonValue));
    }

    /**
     * Fetches person final risk override history
     */
    async findOverrideHistory(requestParameters: FindOverrideHistoryRequest, initOverrides?: RequestInit): Promise<InternalApiFinalRiskOverrideHistoryPage> {
        const response = await this.findOverrideHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Restore final risk override reason
     * Restores final risk override reason from archive
     */
    async restoreOverrideReasonRaw(requestParameters: RestoreOverrideReasonRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.handle === null || requestParameters.handle === undefined) {
            throw new runtime.RequiredError('handle','Required parameter requestParameters.handle was null or undefined when calling restoreOverrideReason.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/risk/final-risk/override-reasons/{handle}/restore`.replace(`{${"handle"}}`, encodeURIComponent(String(requestParameters.handle))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Restore final risk override reason
     * Restores final risk override reason from archive
     */
    async restoreOverrideReason(requestParameters: RestoreOverrideReasonRequest, initOverrides?: RequestInit): Promise<void> {
        await this.restoreOverrideReasonRaw(requestParameters, initOverrides);
    }

}
